var $aRKkE$minimist = require("minimist");
var $aRKkE$path = require("path");
var $aRKkE$express = require("express");
var $aRKkE$fs = require("fs");
var $aRKkE$cors = require("cors");
var $aRKkE$expresshandlebars = require("express-handlebars");
var $aRKkE$ip = require("ip");
var $aRKkE$open = require("open");
var $aRKkE$bodyparser = require("body-parser");
var $aRKkE$reload = require("reload");
var $aRKkE$chokidar = require("chokidar");





var $f14dee9e17222834$var$$parcel$__dirname = $aRKkE$path.resolve(__dirname, "../src");







const $f14dee9e17222834$var$app = $aRKkE$express();
$f14dee9e17222834$var$app.use($aRKkE$bodyparser.json());
var $f14dee9e17222834$var$dirname = '';
var $f14dee9e17222834$var$node_modules;
var $f14dee9e17222834$var$liascriptPath = '';
var $f14dee9e17222834$var$reloadInstance = null;
var $f14dee9e17222834$var$watcher = null;
var $f14dee9e17222834$var$clients = [];
const $f14dee9e17222834$var$gotoScript = `<script>
if (!window.LIA) {
  window.LIA = {}
}

var filename__ = document.location.search.replace("?"+document.location.origin, "")

window.LIA.lineGoto = function(linenumber) {
  fetch("/lineGoto", {
    method: "POST",
    headers: {'Content-Type': 'application/json'}, 
    body: JSON.stringify({
      "linenumber": linenumber,
      "filename": filename__
    })
  }).then(res => {
    console.log("Goto line", linenumber);
  });
}

const events = new EventSource('/gotoLine');
events.onmessage = (event) => {
  try {
    const data = JSON.parse(event.data);
    if (data.filename == filename__) {
      console.log("goto line:", data.linenumber);
      window.LIA.gotoLine(data.linenumber)
    }
  } catch (e) {
    console.warn("gotoLine failed")
  }
};
</script>`;
var $f14dee9e17222834$var$serverPointer;
$f14dee9e17222834$export$2cd8252107eb640b($f14dee9e17222834$var$$parcel$__dirname);
function $f14dee9e17222834$export$2cd8252107eb640b(serverPath, nodeModulesPath) {
    $f14dee9e17222834$var$dirname = serverPath || $aRKkE$path.join($f14dee9e17222834$var$$parcel$__dirname, '..');
    $f14dee9e17222834$var$node_modules = nodeModulesPath || $aRKkE$path.join($f14dee9e17222834$var$dirname, 'node_modules');
    $f14dee9e17222834$var$liascriptPath = $aRKkE$path.resolve($aRKkE$path.join($f14dee9e17222834$var$node_modules, '@liascript/editor/dist'));
}
async function $f14dee9e17222834$export$b3571188c770cc5a(port, hostname, input, responsiveVoice, liveReload, openInBrowser, testOnline, gotoCallback) {
    port = port || 3000;
    hostname = hostname || 'localhost';
    openInBrowser = openInBrowser || false;
    input = input || '.';
    liveReload = liveReload || false;
    testOnline = testOnline || false;
    var project = {
        path: input,
        readme: undefined
    };
    if (input) {
        const stats = $aRKkE$fs.lstatSync(input);
        // Is it a directory?
        if (stats.isDirectory()) project.path = input;
        else if (stats.isFile()) {
            project.path = $aRKkE$path.dirname(input);
            project.readme = $aRKkE$path.basename(input);
        }
    }
    $f14dee9e17222834$var$app.set('view engine', 'hbs');
    $f14dee9e17222834$var$app.engine('hbs', $aRKkE$expresshandlebars({
        layoutsDir: $aRKkE$path.resolve($aRKkE$path.join($f14dee9e17222834$var$dirname, 'views/layouts')),
        defaultLayout: 'main',
        extname: 'hbs'
    }));
    $f14dee9e17222834$var$app.set('views', $aRKkE$path.resolve($aRKkE$path.join($f14dee9e17222834$var$dirname, 'views')));
    // Initialize reload BEFORE routes to ensure its routes are registered first
    if (liveReload) {
        const watchPath = $aRKkE$path.join(project.path, project.readme || '');
        console.log(`\u{2728} watching for changes on: "${watchPath}"`);
        try {
            $f14dee9e17222834$var$reloadInstance = await $aRKkE$reload($f14dee9e17222834$var$app, {
                port: $f14dee9e17222834$var$reloadPort(port)
            });
            // Watch the file for changes using chokidar (more reliable than fs.watch)
            $f14dee9e17222834$var$watcher = $aRKkE$chokidar.watch(watchPath, {
                ignoreInitial: true,
                awaitWriteFinish: {
                    stabilityThreshold: 100,
                    pollInterval: 50
                }
            });
            $f14dee9e17222834$var$watcher.on('change', (filePath)=>{
                console.log("\uD83D\uDCDD file changed, reloading...");
                $f14dee9e17222834$var$reloadInstance.reload();
            });
            $f14dee9e17222834$var$watcher.on('error', (error)=>{
                console.error('Watcher error:', error);
            });
        } catch (err) {
            console.error('Reload could not start:', err);
        }
    }
    $f14dee9e17222834$var$app.get('/', function(req, res) {
        res.redirect('/home');
    });
    $f14dee9e17222834$var$app.get('/gotoLine', $f14dee9e17222834$var$eventsHandler);
    $f14dee9e17222834$var$app.get('/home*', function(req, res) {
        const currentPath = project.path + '/' + req.params[0];
        const stats = $aRKkE$fs.lstatSync(currentPath);
        // Is it a directory?
        if (stats.isDirectory()) {
            const files = $aRKkE$fs.readdirSync(currentPath).filter((e)=>{
                return e[0] !== '.';
            });
            let basePath = '/home';
            let pathNames = req.params[0].split('/').filter((e)=>{
                return e !== '';
            });
            let paths = [];
            for(let i = 0; i < pathNames.length; i++){
                basePath += '/' + pathNames[i];
                paths.push({
                    name: pathNames[i],
                    href: basePath
                });
            }
            res.render('main', {
                layout: 'index',
                path: paths,
                file: files.map((file)=>{
                    return {
                        name: file,
                        href: `http://${hostname}:${port}/home${req.params[0]}/${file}`,
                        isDirectory: $aRKkE$fs.lstatSync(currentPath + '/' + file).isDirectory()
                    };
                }).sort((a, b)=>{
                    if (a.isDirectory && !b.isDirectory) return -1;
                    else if (!a.isDirectory && b.isDirectory) return 1;
                    else {
                        if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) return -1;
                        else return 1;
                    }
                    return 0;
                })
            });
        } else if (stats.isFile()) {
            if (req.params[0].toLocaleLowerCase().endsWith('.md')) {
                if (testOnline) res.redirect(`https://LiaScript.github.io/course/?http://${hostname}:${port}/${req.params[0]}`);
                else res.redirect(`/liascript/index.html?http://${hostname}:${port}/${req.params[0]}`);
            } else res.sendFile(req.params[0], {
                root: project.path
            });
        } else res.send('ups, something went wrong');
    });
    $f14dee9e17222834$var$app.get('/liascript/', function(req, res) {
        res.redirect('/liascript/index.html');
    });
    $f14dee9e17222834$var$app.get('/liascript/index.html', function(req, res) {
        // ------------------------------------
        if (liveReload && responsiveVoice) $aRKkE$fs.readFile($f14dee9e17222834$var$liascriptPath + '/index.html', 'utf8', function(err, data) {
            if (err || !data) {
                res.status(500).send('index.html not found or could not be read');
                return;
            }
            res.send(data.replace('</head>', `<script type='text/javascript' src='/reload/reload.js'></script>
             <script type='text/javascript' src='https://code.responsivevoice.org/responsivevoice.js?key=${responsiveVoice}'></script>
             ${$f14dee9e17222834$var$gotoScript}
             </head>`));
        });
        else if (liveReload) $aRKkE$fs.readFile($f14dee9e17222834$var$liascriptPath + '/index.html', 'utf8', function(err, data) {
            if (err || !data) {
                res.status(500).send('index.html not found or could not be read');
                return;
            }
            res.send(data.replace('</head>', `<script type='text/javascript' src='/reload/reload.js'></script>
                ${$f14dee9e17222834$var$gotoScript}
                </head>`));
        });
        else if (responsiveVoice) $aRKkE$fs.readFile($f14dee9e17222834$var$liascriptPath + '/index.html', 'utf8', function(err, data) {
            if (err || !data) {
                res.status(500).send('index.html not found or could not be read');
                return;
            }
            res.send(data.replace('</head>', `<script type='text/javascript' src='https://code.responsivevoice.org/responsivevoice.js?key=${responsiveVoice}'></script>
                ${$f14dee9e17222834$var$gotoScript}
                </head>`));
        });
        else $aRKkE$fs.readFile($f14dee9e17222834$var$liascriptPath + '/index.html', 'utf8', function(err, data) {
            if (err || !data) {
                res.status(500).send('index.html not found or could not be read');
                return;
            }
            res.send(data.replace('</head>', `${$f14dee9e17222834$var$gotoScript}</head>`));
        });
    });
    // load everything from the liascript folder
    $f14dee9e17222834$var$app.get('/liascript/*', function(req, res) {
        res.sendFile(req.params[0], {
            root: $f14dee9e17222834$var$liascriptPath
        }, (err)=>{
            if (err) {
                // Extract the file path by removing the '/liascript/' prefix
                const projectPath = req.params[0];
                console.log(`File not found in liascriptPath, trying project.path: ${projectPath}`, project.path);
                res.sendFile(projectPath, {
                    root: project.path
                });
            }
        });
    });
    // ignore this one
    $f14dee9e17222834$var$app.get('/sw.js', function(req, res) {});
    $f14dee9e17222834$var$app.get('/favicon.ico', function(req, res) {});
    // react to click-events
    $f14dee9e17222834$var$app.post('/lineGoto', function(req, res) {
        if (gotoCallback) try {
            const linenumber = req.body.linenumber;
            const filename = req.body.filename;
            gotoCallback(linenumber, filename);
        } catch (e) {
            console.warn("lineGoto event with wrong datatype, you have to provide {'linenumber': int, 'filename': string}");
        }
        return res.json({});
    });
    // everything else comes from the current project folder
    $f14dee9e17222834$var$app.use('/*', $aRKkE$cors(), function(req, res, next) {
        // Skip reload and socket.io paths - let reload package handle them
        if (req.originalUrl.startsWith('/reload/') || req.originalUrl.startsWith('/socket.io')) return next();
        res.sendFile(req.originalUrl, {
            root: project.path
        });
    });
    let localURL = 'http://' + hostname + ':' + port;
    if (project.path && project.readme) localURL += '/liascript/index.html?http://' + hostname + ':' + port + '/' + project.readme;
    if (testOnline && project.readme) localURL = 'https://LiaScript.github.io/course/?http://' + hostname + ':' + port + '/' + project.readme;
    const server = $f14dee9e17222834$var$app.listen(port);
    server.on('error', (e)=>{
        throw e;
    });
    if (openInBrowser) $aRKkE$open(localURL);
    console.log("\uD83D\uDCE1 starting server");
    console.log(`   - local:           ${localURL}`);
    console.log(`   - on your network: ${localURL.replace(hostname, $aRKkE$ip.address())}`);
    $f14dee9e17222834$var$serverPointer = server;
}
function $f14dee9e17222834$export$fa6813432f753b0d() {
    if ($f14dee9e17222834$var$serverPointer) $f14dee9e17222834$var$serverPointer.close();
    if ($f14dee9e17222834$var$watcher) {
        $f14dee9e17222834$var$watcher.close();
        $f14dee9e17222834$var$watcher = null;
    }
    if ($f14dee9e17222834$var$reloadInstance) {
        $f14dee9e17222834$var$reloadInstance.closeServer().catch(()=>{});
        $f14dee9e17222834$var$reloadInstance = null;
    }
}
// keeps the live-reload websocket port derived from (and as unique as) the
// main devserver port, instead of reload's hardcoded 9856 default, so
// multiple simultaneously running instances never collide
function $f14dee9e17222834$var$reloadPort(port) {
    return port < 55535 ? port + 10000 : port - 10000;
}
function $f14dee9e17222834$export$5d5b784f9a618ec3(linenumber, filename) {
    $f14dee9e17222834$var$clients.forEach((client)=>client.response.write(`data: ${JSON.stringify({
            linenumber: linenumber,
            filename: filename
        })}\n\n`));
}
function $f14dee9e17222834$var$eventsHandler(request, response, next) {
    const headers = {
        'Content-Type': 'text/event-stream',
        Connection: 'keep-alive',
        'Cache-Control': 'no-cache'
    };
    response.writeHead(200, headers);
    const data = `data: \n\n`;
    response.write(data);
    const clientId = Date.now();
    const newClient = {
        id: clientId,
        response: response
    };
    $f14dee9e17222834$var$clients.push(newClient);
    request.on('close', ()=>{
        //console.log(`${clientId} Connection closed`)
        $f14dee9e17222834$var$clients = $f14dee9e17222834$var$clients.filter((client)=>client.id !== clientId);
    });
}



const $71fcc9ea54afc905$var$argv = $aRKkE$minimist(process.argv.slice(2));
function $71fcc9ea54afc905$var$liascript() {
    console.log(' _     _       ____            _       _');
    console.log('| |   (_) __ _/ ___|  ___ _ __(_)_ __ | |_');
    console.log("| |   | |/ _` \\___ \\ / __| '__| | '_ \\| __|");
    console.log('| |___| | (_| |___) | (__| |  | | |_) | |_ ');
    console.log('|_____|_|\\__,_|____/ \\___|_|  |_| .__/ \\__|');
    console.log('                                |_|');
    console.log();
}
if ($71fcc9ea54afc905$var$argv.v || $71fcc9ea54afc905$var$argv.version) {
    console.log('DevServer: 1.2.10');
    console.log('LiaScript: 1.1.0');
    process.exit();
}
if ($71fcc9ea54afc905$var$argv.h || $71fcc9ea54afc905$var$argv.help) {
    $71fcc9ea54afc905$var$liascript();
    console.log('-h  --help       show this help');
    console.log('-v  --version    show version information');
    console.log('-i  --input      input README.md file or folder (default: .)');
    console.log('-n  --hostname   hostname of your server (default: localhost)');
    console.log('-p  --port       used port number (default: 3000)');
    console.log('-l  --live       do live reload on file change');
    console.log('-o  --open       open in default browser');
    console.log('-t  --test       test online on https://LiaScript.github.io');
    console.log();
    console.log('-r  --responsiveVoice  add optional responsiveVoice support,');
    console.log('                       or pass your own responsiveVoice key.');
    console.log('                       Adding this feature might slow down');
    console.log('                       the reloading speed.');
    console.log('                       For more information visit:');
    console.log('                       https://responsivevoice.org');
    process.exit();
}
$71fcc9ea54afc905$var$liascript();
$f14dee9e17222834$export$2cd8252107eb640b($71fcc9ea54afc905$var$argv.node_modules);
$f14dee9e17222834$export$b3571188c770cc5a($71fcc9ea54afc905$var$argv.p || $71fcc9ea54afc905$var$argv.port, $71fcc9ea54afc905$var$argv.n || $71fcc9ea54afc905$var$argv.hostname, $71fcc9ea54afc905$var$argv.i || $71fcc9ea54afc905$var$argv.input, $71fcc9ea54afc905$var$argv.r || $71fcc9ea54afc905$var$argv.responsiveVoice || process.env.RESPONSIVE_VOICE_KEY, $71fcc9ea54afc905$var$argv.l || $71fcc9ea54afc905$var$argv.live, $71fcc9ea54afc905$var$argv.o || $71fcc9ea54afc905$var$argv.open, $71fcc9ea54afc905$var$argv.t || $71fcc9ea54afc905$var$argv.test).catch((e)=>{
    console.error('Error: ', e.message);
    process.exit();
});
console.log("\u2728 hit Ctrl-c to close the server");


//# sourceMappingURL=index.js.map
